import React from "react";

export function NotFound() {
  return <div>Not found</div>;
}
